import axios from "axios";
import toast from "../../../template/layout/utility/sa-toast";
export default {
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	data() {
		return {
			isBusy: false,
			magazzinoArticoli: [],
			magazzinoArticoliRecordNumbers: 0,
			magazzinoArticoliPathResources: "/magazzinoarticoli",


			magazzinoArticoliCodiciGiacenza: [],
			magazzinoArticoliCodiciGiacenzaRecordNumbers: 0,
			magazzinoArticoliCodiciGiacenzaPathResources: "/magazzinoarticoli/giacenza/codici",

			magazzinoArticolo: { nomeArticolo: null, giacenze: 0 },

			magazzinoArticoliGiacenzaItems: [],
			magazzinoArticoliGiacenzaRecordNumbers: 0,
			magazzinoArticoliGiacenzaPathResources: "/magazzinoarticoli/giacenze",


			magazzinoArticoliLottiItems: [],
			magazzinoArticoliLottiPathResources: "/magazzinoarticolilottiscadenze/giacenza",
			magazzinoArticoliLottiRecordNumbers: 0,


			magazzinoArticoliUnitaMisuraBaseOptions: [],
			magazzinoArticoliUnitaMisuraOptions: [],
			magazzinoArticoliUnitaMisuraPathResources: "/magazzinoarticolium",

			magazzinoMagazziniOptions: [],
			magazzinoMagazziniPathResources: "/magazzinomagazzini",

			magazzinoArticoliMovimentazioneGiacenzaItems: [],
			magazzinoArticoliMovimentazioneGiacenzaRecordNumbers: 0,
			magazzinoArticoliMovimentazioneGiacenzaPathResources: "/magazzinoarticoli/storicogiacenze",

			magazzinoArticoliMovimentazioneContabileItems: [],
			magazzinoArticoliMovimentazioneContabileRecordNumbers: 0,
			magazzinoArticoliMovimentazioneContabilePathResources: "/magazzinoarticoli/storicocontabile",

			magazzinoJsonData: {},
			articoliFields: [
				{ key: "index" },
				{
					key: "codiceArticolo",
					label: "Codice Articolo",
				},
				{
					key: "nomeArticolo",
					label: "Nome Articolo",
				},
				{
					key: "descrizioneArticolo",
					label: "Descrizione",
				},
				{
					key: "giacenze",
					label: "Giacenza",
				},
				{
					key: "categoria",
					label: "Categoria",
				},
				{
					key: "umId",
					label: "Multiplo",
				},
				{
					key: "matricoleLotti",
					label: "Gestione Matricole/Lotti",
				},
				{
					key: "actions",
					label: "",
				},
			],
		};
	},
	computed: {
		magazziniFisici() {
			return this.magazzinoMagazziniOptions.filter((e) => e.tipo === "FISICO");
		},
	},
	methods: {
		magazzinoArticoloDettaglio(id) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliPathResources + "/" + id;
			this.magazzinoArticolo = { nomeArticolo: null, giacenze: 0 },
				axios.get(link)
					.then((response) => {
						this.magazzinoArticolo = response.data.data;
					})
					.catch((error) => {
						toast.error(error)
					});
		},


		magazzinoArticoloLottiLoadResource(filtro) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliLottiPathResources;
			this.magazzinoArticoliLottiItems = [];
			this.openShowModalLoading();
			axios.get(link, { params: filtro })
				.then((response) => {
					this.magazzinoArticoliLottiItems = response.data.data.list;
					this.magazzinoArticoliLottiRecordNumbers = response.data.data.recordsNumber;
					this.closeShowModalLoading();
				})
				.catch((error) => {
					toast.error(error);
					this.closeShowModalLoading();
				});
		},

		magazzinoArticoliMovimentazioneContabile(filtro) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliMovimentazioneContabilePathResources;
			this.magazzinoArticoliMovimentazioneContabileItems = [];
			this.openShowModalLoading();
			axios.get(link, { params: filtro })
				.then((response) => {
					this.magazzinoArticoliMovimentazioneContabileItems = response.data.data.list;
					this.magazzinoArticoliMovimentazioneContabileRecordNumbers = response.data.data.recordsNumber;
					this.closeShowModalLoading();
				})
				.catch((error) => {
					toast.error(error)
					this.closeShowModalLoading();
				});
		},
		magazzinoArticoliMovimentazioneGiacenza(filtro) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliMovimentazioneGiacenzaPathResources;
			this.magazzinoArticoliMovimentazioneGiacenzaItems = [];
			this.openShowModalLoading();
			axios.get(link, { params: filtro })
				.then((response) => {
					this.magazzinoArticoliMovimentazioneGiacenzaItems = response.data.data.list;
					this.magazzinoArticoliMovimentazioneGiacenzaRecordNumbers = response.data.data.recordsNumber;
					this.closeShowModalLoading();
				})
				.catch((error) => {
					toast.error(error)
					this.closeShowModalLoading();
				});
		},

		magazzinoArticoloMatricoleLoadResource(filtro) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliMatricolePathResources;
			this.magazzinoArticoliMatricoleItems = [];
			axios.get(link, { params: filtro })
				.then((response) => {
					this.magazzinoArticoliMatricoleItems = response.data.data;
				})
				.catch((error) => {
					toast.error(error)
				});
		},
		magazzinoArticoloMatricoleLoadResourceCallBack(filtro, callback) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliMatricolePathResources;
			this.magazzinoArticoliMatricoleItems = [];
			axios.get(link, { params: filtro })
				.then((response) => {
					this.magazzinoArticoliMatricoleItems = response.data.data;
					callback(response.data.data);
				})
				.catch((error) => {
					toast.error(error)
				});
		},

		magazzinoMagazziniLoadData(filtro) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoMagazziniPathResources;
			this.magazzinoMagazziniOptions = [];
			axios.get(link, { params: filtro })
				.then((response) => {
					this.magazzinoMagazziniOptions = response.data.data.list;
				})
				.catch((error) => {
					toast.error(error)
				});
		},

		magazzinoByCodiceMagazzinoLoadData(codiceMagazzino, codiceStruttura, callbacksuccess, callbackerror = null) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoMagazziniPathResources + "/" + codiceMagazzino;
			this.magazzinoJsonData = {};
			axios.get(link, { params: { codiceStruttura: codiceStruttura } })
				.then((response) => {
					this.magazzinoJsonData = response.data.data;
					callbacksuccess(response.data.data);
				})
				.catch((error) => {
					if (callbackerror) {
						callbackerror(error);
					} else {
						toast.error(error)
					}
				});
		},

		magazzinoArticoliGiacenzeLoadData(filtro) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliGiacenzaPathResources;
			this.magazzinoArticoliGiacenzaItems = [];
			this.openShowModalLoading();


			axios.get(link, { params: filtro })
				.then((response) => {
					this.magazzinoArticoliGiacenzaItems = response.data.data.list;
					this.magazzinoArticoliGiacenzaRecordNumbers = response.data.data.recordsNumber;
					this.closeShowModalLoading();
				})
				.catch((error) => {
					this.closeShowModalLoading();
					toast.error(error)
				});
		},

		magazzinoArticoliLoadData(filtro) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliPathResources;
			this.openShowModalLoading();
			axios.get(link, { params: filtro })

				.then((response) => {
					this.magazzinoArticoliRecordNumbers = response.data.data.recordsNumber;
					this.magazzinoArticoli = response.data.data.list;
					this.closeShowModalLoading();
				})
				.catch((error) => {
					toast.error(error)
					this.closeShowModalLoading();
				});
		},
		magazzinoArticoliCodiciGiacenzaLoadData(filtro) {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliCodiciGiacenzaPathResources;
			this.openShowModalLoading();
			this.magazzinoArticoliCodiciGiacenzaRecordNumbers = [];
			axios.get(link, { params: filtro })
				.then((response) => {
					this.magazzinoArticoliCodiciGiacenzaRecordNumbers = response.data.data.recordsNumber;
					this.magazzinoArticoliCodiciGiacenza = response.data.data.list;
					this.closeShowModalLoading();
				})
				.catch((error) => {
					toast.error(error)
					this.closeShowModalLoading();
				});
		},

		mangazzinoArticoliUnitaMisuraLoadData() {
			let link = process.env.VUE_APP_PATH_API + this.magazzinoArticoliUnitaMisuraPathResources;
			this.magazzinoArticoliUnitaMisuraOptions = [];
			axios.get(link)
				.then((response) => {
					this.magazzinoArticoliUnitaMisuraOptions = response.data.data.list;
					this.magazzinoArticoliUnitaMisuraBaseOptions = response.data.data.list.filter(e => e.multiplo == 1);
				})
				.catch((error) => {
					toast.error(error);
				});
		},


	},
};
